import { useState } from "react";

const useModal = (value = false) => {
  const [isShowing, setIsShowing] = useState(value);

  function toggle() {
    setIsShowing(!isShowing);
  }

  return {
    isShowing,
    toggle,
  };
};

export default useModal;
